<button mat-stroked-button (click)="downloadInvoice($event, invoice.id)" [disabled]="xhrInProgress">{{'invoices.download' | translate}} <mat-icon class="spin" *ngIf="xhrInProgress">cached</mat-icon></button>
